import React from 'react';
import './index.css';
import clsx from 'classnames';
import QueueAnim from 'rc-queue-anim';

const Compare = () => {
  //  数智化实验室
  const advantageList = [
    { name: '检测过程数据化' },
    { name: '检测流程规范化' },
    { name: '人员/设备管理数字化' },
    { name: '检测活动透明化' },
    { name: '平台部署多样化' },
  ];

  // 传统实验室
  const oldAdvantageList = [
    { name: '效率低/不规范' },
    { name: '流程复杂/协作困难' },
    { name: '重复性高/耗时耗力' },
    { name: '时效性差/准确度低' },
  ];

  return (
    <QueueAnim
      className={clsx('intelligence-compare')}
      type={['bottom', 'top']}
    >
      <div
        className={clsx('intelligence-compare-title')}
        key='intelligence-compare-title'
      >
        实验室对比
      </div>
      <div
        className={clsx('intelligence-compare-text')}
        key='intelligence-compare-text'
      >
        多维对比，全面领先
      </div>
      <div
        className={clsx('intelligence-compare-info')}
        key='intelligence-compare-info'
      >
        <QueueAnim
          className={clsx('intelligence-compare-info-left')}
          type={['left', 'right']}
        >
          <div
            className={clsx('intelligence-compare-info-left__img')}
            key='intelligence-compare-info-left__img'
          />
          <div
            className={clsx('intelligence-compare-info-left__title')}
            key='intelligence-compare-info-left__title'
          >
            数智化实验室
          </div>
          <div
            className={clsx('intelligence-compare-info-left__line')}
            key='intelligence-compare-info-left__line'
          />
          <div
            className={clsx('intelligence-compare-info-left__list')}
            key='intelligence-compare-info-left__list'
          >
            {advantageList.map((item, index) => (
              <div
                key={index}
                className={clsx('intelligence-compare-info-left__text')}
              >
                <img src='/img/advantage.png' alt='' width={25} height={25} />
                {item.name}
              </div>
            ))}
          </div>
        </QueueAnim>
        <QueueAnim
          className={clsx('intelligence-compare-info-right')}
          type={['right', 'left']}
        >
          <div
            className={clsx('intelligence-compare-info-right__img')}
            key='intelligence-compare-info-right__img'
          />
          <div
            className={clsx('intelligence-compare-info-right__title')}
            key='intelligence-compare-info-right__title'
          >
            传统实验室
          </div>
          <div
            className={clsx('intelligence-compare-info-left__line')}
            key='intelligence-compare-info-left__line'
          />
          <div
            className={clsx('intelligence-compare-info-right__list')}
            key='intelligence-compare-info-right__list'
          >
            {oldAdvantageList.map((item, index) => (
              <div
                key={index}
                className={clsx('intelligence-compare-info-right__text')}
              >
                {item.name}
              </div>
            ))}
          </div>
        </QueueAnim>
      </div>
    </QueueAnim>
  );
};

export default Compare;
